<template>
  <div class="animated fadeIn">
        <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <v-col
      lg="12"
      class="ml-auto"
    ></v-col>
    <b-card
      header-bg-variant="primary"
      header-text-variant="white"
    >
      <template v-slot:header>
        <h6>الگوهای سازمانی</h6>
      </template>

      <br />

      <b-card
        header-bg-variant="secondary"
        header-text-variant="white"
      >
        <template v-slot:header>
          <h6>متن بالای استعلام - فارسی</h6>
        </template>
        <p style="direction:rtl">شرکت <strong>؟؟؟؟؟</strong></p>
        <p style="direction:rtl">جناب آقای/سرکار خانم <strong>؟؟؟؟؟</strong></p>
        <p style="direction:rtl">با سلام احتراما ًعطف به استعلام بهای <strong>؟؟؟؟؟</strong> مورخ <strong>؟؟؟؟؟</strong>،
          پیشنهاد فنی / مالی مربوطه به شرح ذیل تقدیم حضور میگردد.</p>
      </b-card>
      <hr />
      <b-card
        header-bg-variant="secondary"
        header-text-variant="white"
      >
        <template v-slot:header>
          <h6>متن بالای استعلام - انگلیسی</h6>
        </template>
        <div dir="ltr">
          <p>Company name: <strong>?????</strong></p>
          <p>Dear Mr./Ms. <strong>?????</strong></p>
          <p>According to the recieved letter No. <strong>?????</strong> dated <strong>?????</strong>,
            the quotation is been prepared as the following table.</p>
        </div>
      </b-card>
      <hr />
      <b-card
        header-bg-variant="secondary"
        header-text-variant="white"
      >
        <template v-slot:header>
          <h6>متن پایین استعلام - فارسی</h6>
        </template>
        <p style="direction:rtl"><strong>ملاحظات فنی:</strong></p>
        <p>استاندارد ابعاد :ASME B16.5 &amp; ASME B18.2.2</p>
        <p>استاندارد رزوه:&nbsp;ASME B1.1 UNC FOR SIZES UP TO 1&quot; AND UN8 FOR SIZES ABOVE 1&quot; is applied</p>
        <p>NOTE: NUTS ARE HEAVY</p>
        <p style="direction:rtl">توجه: تمامی تست ها قبل از عملیات پوشش انجام خواهد شد.</p>
        <p style="direction:rtl">&nbsp;</p>
        <p style="direction:rtl"><strong>شرایط فروش</strong></p>
        <p style="direction:rtl">پیش پرداخت : &nbsp;50% &nbsp;الباقی پس از تاییدیه و قبل از حمل</p>
        <p style="direction:rtl">زمان تحویل : &nbsp; هفته کاری پس از دریافت پیش پرداخت</p>
        <p style="direction:rtl">مكان تحویل : &nbsp;درب كارخانه پولاد پیچ كار</p>
        <p style="direction:rtl">اعتبار پیشنهاد قیمت : 2 روز</p>
        <p style="direction:rtl">بسته بندی : كارتن یا پالت چوبی</p>
        <p style="direction:rtl">گواهی كیفیت مطابق MATERIAL TEST CERTIFICATE WILL BE PROVIDED ACC TO DIN EN 10204 3.1b</p>
      </b-card>
      <hr />
      <b-card
        header-bg-variant="secondary"
        header-text-variant="white"
      >
        <template v-slot:header>
          <h6>متن پایین استعلام - انگلیسی</h6>
        </template>
        <p style="direction:ltr;">DIMENSION: ASME B16.5 &amp; B18.2.2</p>
        <p>DELIVERY CONDITION</p>
        <p>PREPAYMENT : 50%</p>
        <p>DELIVERY TIME: 2 TO 4 WEEKS AFTER RECEIVEING ADVANCE PAYMENT.</p>
        <p>DELIVERY TERM: EX.WORK</p>
        <p>VALIDITY: 2 DAYS</p>
        <p>PACKING: CARTONS OR PALLETS</p>
        <p>MATERIAL TEST CERTIFICATE WILL BE PROVIDED ACC TO DIN EN 10204 3.1b</p>
      </b-card>
      <br />
    </b-card>

  </div>
</template>

<script>
export default {
  components: {},
  data: function() {
    return {
      guide: false,
    }
  },

  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
  },

  mounted() {}
}
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url('../assets/fonts/IRANSans(FaNum).ttf');
}
</style>

